import { Group } from '@mantine/core';
import { Icon } from '@repo/foundations';
import { useMemo } from 'react';
import type { EnhancedNotification, INotificationTitleProps } from '../types';
import { getNotificationIconConfig } from '../utils/notificationIconUtils';

export function NotificationStatus({ notification }: INotificationTitleProps) {
	const enhancedNotification = notification as EnhancedNotification;

	const iconData = useMemo(
		() => getNotificationIconConfig(enhancedNotification),
		[enhancedNotification]
	);

	const { iconName, color, fillColor, label, invisible } = iconData;

	return (
		<Group spacing="xs" align="center" noWrap>
			<Icon
				aria-label={label}
				name={iconName}
				color={color}
				fillColor={fillColor}
				size="md"
				style={{ opacity: invisible ? 0 : 1 }}
			/>
		</Group>
	);
}
